export const TABLE_PRICE = 'Table Price';
export const TIME_UPGRADE = 'Table upgrade';
export const COUPON_DISCOUNT = 'Coupon discount';
export const VIP_DISCOUNT = 'VIP savings';
export const FACILITIES_FEE = 'Facilities Fee';
